import { FormControl, FormArray, FormGroup } from '@angular/forms';
import { RatingType } from '@empathy/survey/base';

import { NotepadQuestion } from './notepad-model.model';
import { ExtendedQuestionType } from './notepad-question-type.constant';

export class NotepadForm {
  programmerNotes: FormControl<string>;
  questions: FormArray<FormGroup<NotepadQuestionForm>>;
}

export class NotepadQuestionForm {
  questionId: FormControl<string>;
  questionText?: FormControl<string>;
  mandatoryInd: FormControl<boolean>;
  questionType: FormControl<ExtendedQuestionType>;
  options?: FormArray<FormControl<string>>;
  cards?: FormArray<FormControl<string>>;
  ranks?: FormArray<FormControl<string>>;
  otherOptionInd: FormControl<boolean>;
  noneOptionInd: FormControl<boolean>;
  randomizeOptionsInd: FormControl<boolean>;
  instructions: FormControl<string>;
  programmerNotes: FormControl<string>;
  ratingType: FormControl<RatingType>;

  constructor(question: NotepadQuestion) {
    this.questionId = new FormControl<string>(question.questionId);
    this.questionText = new FormControl<string>(question.questionText);
    this.mandatoryInd = new FormControl<boolean>(question.mandatoryInd);
    this.questionType = new FormControl<ExtendedQuestionType>(question.questionType);
    this.options = new FormArray(question.options?.map((option) => new FormControl<string>(option)) ?? []);
    this.cards = new FormArray(question.cards?.map((card) => new FormControl<string>(card)) ?? []);
    this.ranks = new FormArray(question.ranks?.map((rank) => new FormControl<string>(rank)) ?? []);
    this.otherOptionInd = new FormControl<boolean>(question.otherOptionInd);
    this.noneOptionInd = new FormControl<boolean>(question.noneOptionInd);
    this.randomizeOptionsInd = new FormControl<boolean>(question.randomizeOptionsInd);
    this.instructions = new FormControl<string>(question.instructions);
    this.programmerNotes = new FormControl<string>(question.programmerNotes);
    this.ratingType = new FormControl<RatingType>(question.ratingType);
  }
}
